import React, { FC, ReactNode } from 'react'

import classes from './plan-card-inner.module.scss'

interface PlanCardInnerProps {
  background?: string
  hasBorder?: boolean
  children?: ReactNode
  dataTestId?: string
}

export const PlanCardInner: FC<PlanCardInnerProps> = ({
  background,
  hasBorder,
  children,
  dataTestId,
}) => (
  <div
    className={classes.wrapper}
    data-testid={dataTestId}
    style={{
      background,
      borderRight: hasBorder ? '1px solid grey' : undefined,
    }}
  >
    {children}
  </div>
)

export default PlanCardInner
